export default __webpack_public_path__ + "static/media/faq.7839a7e3.svg";